import { handleActions } from 'redux-actions';
import { GuiStateActions } from 'app/actions/guiState/guiStateAction.ts';
import { SIDEBAR_STATE_STORAGE_KEY } from 'app/constants/storageKeys.ts';
import type ChartDOMSize from '../../models/guiState/chartDomPosition.ts';

// FIXME: i've no better ideas atm, use this as fallback in case nothing is specified
function getWindowSize(): ChartDOMSize {
  return {
    chartDOMWidth: window.innerWidth ?? 0,
    chartDOMHeight: window.innerHeight ?? 0
  };
}

function getInitialSideMenuOpen(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return localStorage.getItem(SIDEBAR_STATE_STORAGE_KEY) === 'true';
  } catch (_error) {
    return false;
  }
}

export interface IGuiState {
  sideMenuOpen: boolean;
  chartDOMSize: ChartDOMSize;
}

const initialState: IGuiState = {
  sideMenuOpen: getInitialSideMenuOpen(),
  chartDOMSize: getWindowSize()
};

export const guiStateReducer = handleActions<IGuiState, boolean | ChartDOMSize>(
  {
    [GuiStateActions.Type.SET_SIDE_MENU_OPEN]: (state, action): IGuiState => {
      return { ...state, sideMenuOpen: action.payload as boolean };
    },
    [GuiStateActions.Type.SET_CHART_PARAMS]: (state, action): IGuiState => {
      return { ...state, chartDOMSize: action.payload as ChartDOMSize };
    }
  },
  initialState
);
